module.exports = __webpack_public_path__ + "img/prendho.5b07b5dd.png";